export type ResourceName<C extends string> = `${C}/${string}`;

export const isResourceName = <C extends string>(
  name: string,
  collection: C,
): name is ResourceName<C> => name.startsWith(`${collection}/`);

// Parses newline-separated text into the unique resource names of a
// collection, ignoring lines that are anything else.
export const parseResourceNames = <C extends string>(
  content: string,
  collection: C,
): ResourceName<C>[] => {
  const names = content
    .split('\n')
    .map(line => line.trim())
    .filter((name): name is ResourceName<C> =>
      isResourceName(name, collection),
    );
  return [...new Set(names)];
};

export const extractLastNameComponent = (name: string | undefined) => {
  if (name === undefined) {
    return undefined;
  }

  const parts = name.split('/');
  if (parts.length <= 0) {
    return name;
  }

  return parts[parts.length - 1];
};

export const extractLastNameComponentFromName = (name: string) => {
  const parts = name.split('/');
  return parts[parts.length - 1];
};

// TODO: move this to workflow package when created
// Extract the workflow type from a name with
// pattern `workflows/<type>/instances/<instance-id>`
export const extractWorkflowFromInstanceName = (name: string | undefined) => {
  if (name === undefined) {
    return undefined;
  }

  const parts = name.split('/');
  if (parts.length <= 0) {
    return name;
  }

  return parts[1];
};
